import { render, staticRenderFns } from "./SearchByThematic.vue?vue&type=template&id=6dacc22b&"
import script from "./SearchByThematic.vue?vue&type=script&lang=js&"
export * from "./SearchByThematic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports